import React from 'react';
import T from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  FLEX_DRAFT_REVIEW_DICTIONARY,
  PAYMENT_FLOW_TYPE_FLEX_DRAFT,
} from '@dmi/shared/redux/Payments/FlexDraft/constants';
import {
  selectSetUpFlexDraftReviewData,
  selectSetUpRowButtonsProps,
  selectSummaryScheduledDateString,
} from '@dmi/shared/redux/Payments/FlexDraft/selectors';

import ReviewScreen from '../../../components/Payments/Review';

const Review = ({
  navigation,
  paymentSummarySubText,
  setUpReviewData,
  setUpRowButtonsProps: { amountRowValue },
}) => (
  <ReviewScreen
    navigation={navigation}
    paymentFlowType={PAYMENT_FLOW_TYPE_FLEX_DRAFT}
    reviewData={setUpReviewData}
    reviewDictionary={FLEX_DRAFT_REVIEW_DICTIONARY}
    summaryProps={{
      label: 'Next',
      onPress: () => navigation.navigateDeprecated('FlexDraftDisclosure'),
      subText: paymentSummarySubText,
      text: amountRowValue,
    }}
  />
);

Review.propTypes = {
  navigation: T.object.isRequired,
  paymentSummarySubText: T.string.isRequired,
  setUpReviewData: T.array.isRequired,
  setUpRowButtonsProps: T.object.isRequired,
};

const mapStateToProps = createStructuredSelector({
  /**
   * Store: Flex Draft
   */
  paymentSummarySubText: selectSummaryScheduledDateString(),
  setUpReviewData: selectSetUpFlexDraftReviewData(),
  setUpRowButtonsProps: selectSetUpRowButtonsProps(),
});

const mapDispatchToProps = () => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Review);
